<div class="radial-gradient">
  <router-outlet></router-outlet>
</div>
